goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ArrowRight$default");
shadow.js.shim.module$$carbon$icons_react$es$ArrowRight$default = shadow.js.require(350, {}).default;
